import { t as __t } from "i18next";
import React, { useEffect, useState } from "react";
import { notifyListRefresh } from "../../../utils/listNavigation";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import moment from "moment";

import DashboardHeader from "../../../components/header/DashboardHeader";
import DashboardEmployerSidebar from "../../../components/header/DashboardSidebar";
import MobileMenu from "../../../components/header/MobileMenu";
import CopyrightFooter from "../../../components/footer/employers/CopyrightFooter";
import BackPrevious from "../../../components/back-previous";
import FileUploadGrid from "../../../components/upload-file";
import SwalAlert from "../../../components/common/alert";

import { Gallery, Item } from "react-photoswipe-gallery";

import {
	approveClameLifeContract,
	callGetApproveContract,
} from "../../../api/contract/service";

import { callUploadFile } from "../../../api/settings/service";
import { callExportClameVehiclePDF } from "../../../api/export";

import {
	decodeBase64,
	displayUrl,
	FormatCurrencys,
	dateToString,
	isLa,
	convertStringToJson,
} from "../../../utils/commonUtil";

import "../../../components/i18n/lang";
import "./approve.css";
import { Modal } from "bootstrap";
import { openDocumentPreview } from "../../../components/document-preview";

const Index = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const params = useParams();
	const { t } = useTranslation();

	const userInfo = useSelector((state) => state.dataLogin);

	const [id, setId] = useState(null);
	const [contract, setContract] = useState(null);
	const [clame, setClame] = useState(null);
	const [view, setView] = useState(false);
	const [loading, setLoading] = useState(true);
	const [submitting, setSubmitting] = useState(false);
	const [downloadingType, setDownloadingType] = useState(null);

	const [request, setRequest] = useState({
		file: null,
	});

	useEffect(() => {
		if (!params?.id) {
			setLoading(false);
			return;
		}

		const decodedValue = decodeBase64(params.id);
		console.log(decodedValue)
		const data = JSON.parse(decodedValue);

		setView(Boolean(data?.view));
		setId(data.id);
		loadData(data.id);
	}, [params?.id]);

	const parseJsonArray = (value) => {
		if (!value) return [];

		try {
			const parsed = convertStringToJson(value);
			return Array.isArray(parsed) ? parsed : [];
		} catch (error) {
			console.error("Parse JSON error:", error);
			return [];
		}
	};

	const loadData = async (requestId) => {
		try {
			setLoading(true);

			const rsp = await dispatch(
				callGetApproveContract({
					requestId,
				})
			);

			if (rsp?.payload?.responseCode !== "00000") {
				SwalAlert.error(
					__t("uiText.text023"),
					`${rsp?.payload?.responseCode || ""} - ${rsp?.payload?.responseDescription ||
					__t("uiText.text096")
					}`
				);
				return;
			}

			const data = rsp?.payload?.data;

			setContract({
				...data?.contract,
				imagePath: parseJsonArray(data?.contract?.imagePath),
			});

			setClame(data?.requestClaim || null);
		} catch (error) {
			console.error("Load claim error:", error);

			SwalAlert.error(
				__t("uiText.text023"),
				__t("uiText.text024")
			);
		} finally {
			setLoading(false);
		}
	};

	const handleImageSelect = (files) => {
		if (files?.files?.[0]) {
			setRequest({
				file: {
					file: files,
				},
			});
			return;
		}

		setRequest({
			file: null,
		});
	};

	const handleSave = async (status, description) => {
		if (!request?.file?.file) {
			SwalAlert.error(
				__t("uiText.text019"),
				__t("uiText.text097")
			);
			return;
		}

		SwalAlert.confirm(
			t("swal.title.approve"),
			t("swal.text.confirmApprove"),
			async () => {
				try {
					setSubmitting(true);

					const upload = await dispatch(
						callUploadFile(request.file.file)
					);

					if (upload?.payload?.responseCode !== "00000") {
						SwalAlert.error(
							__t("uiText.text033"),
							upload?.payload?.responseDescription ||
							t("uploadFile.heirs2")
						);
						return;
					}

					const req = {
						approvedPath: JSON.stringify(
							upload?.payload?.data || []
						),
						id,
						status,
						description,
						modifiedCode:
							userInfo?.data?.user?.userId,
						modifiedName: [
							userInfo?.data?.user?.firstName,
							userInfo?.data?.user?.lastName,
						]
							.filter(Boolean)
							.join(" "),
					};

					const rsp = await dispatch(
						approveClameLifeContract(req)
					);

					if (rsp?.payload?.responseCode === "00000") {
						const myModal = document.getElementById("approvedPopupModal");
						const modal = Modal.getInstance(myModal);
						modal.hide();

						notifyListRefresh();
						navigate("/admin/approved/vehicleInsurance");
						return;
					}

					SwalAlert.error(
						__t("uiText.text034"),
						`${rsp?.payload?.responseCode || ""} - ${rsp?.payload?.responseDescription || ""
						}`
					);
				} catch (error) {
					console.error("Approve claim error:", error);

					SwalAlert.error(
						__t("uiText.text023"),
						__t("uiText.text024")
					);
				} finally {
					setSubmitting(false);
				}
			}
		);
	};

	const handleSubmitApprove = (event) => {
		event.preventDefault();

		handleSave(2, "approve insurance");
	};

	const downloadPDF = async (requestId, type) => {
		if (!requestId) return;

		try {
			setDownloadingType(type);

			const response = await callExportClameVehiclePDF({
				requestId,
				type,
				typeSql: 1
			});

			if (!response) {
				SwalAlert.error(
					__t("uiText.text035"),
					__t("uiText.text036")
				);
				return;
			}

			const url = URL.createObjectURL(response);
			const link = document.createElement("a");

			link.href = url;
			link.download = `clame_${moment().format(
				"YYYYMMDDHHmmss"
			)}.pdf`;

			document.body.appendChild(link);
			link.click();
			link.remove();

			URL.revokeObjectURL(url);
		} catch (error) {
			console.error("Download PDF error:", error);

			SwalAlert.error(
				__t("uiText.text035"),
				__t("uiText.text037")
			);
		} finally {
			setDownloadingType(null);
		}
	};

	const openClaimDocument = () => {
		const documents = parseJsonArray(clame?.documentPath);

		if (!documents.length) {
			SwalAlert.error(
				__t("uiText.text098"),
				__t("uiText.text099")
			);
			return;
		}

		if (documents) openDocumentPreview(documents);
	};

	const displayValue = (value) => {
		if (
			value === null ||
			value === undefined ||
			value === ""
		) {
			return "-";
		}

		return value;
	};

	return (
		<div className="page-wrapper dashboard claim-vehicle-page">
			<span className="header-span" />

			<DashboardHeader />
			<MobileMenu />
			<DashboardEmployerSidebar />

			<section className="user-dashboard">
				<div className="dashboard-outer">
					<div className="claim-page-header">
						<div className="claim-page-title">
							<BackPrevious />

							<div>
								<span className="claim-page-subtitle">
									{__t("uiText.text422")}</span>

								<h3>{t("contracts.clame")}</h3>

								<p>
									{__t("uiText.text100")}</p>
							</div>
						</div>

						{/* {clame && (
							<div className="claim-status">
								<i className="fas fa-clock" />
								ລໍຖ້າກວດສອບ
							</div>
						)} */}
						{clame && (
							<div
								className={`claim-view-badge ${view
									? "claim-view-only"
									: "claim-pending"
									}`}
							>
								<i
									className={
										view
											? "fas fa-eye"
											: "fas fa-clock"
									}
								/>

								{view
									? __t("uiText.text045")
									: __t("uiText.text046")}
							</div>
						)}

					</div>

					{loading && (
						<div className="claim-loading">
							<div
								className="spinner-border text-primary"
								role="status"
							/>
							<span>{__t("uiText.text047")}</span>
						</div>
					)}

					{!loading && contract && (
						<>
							<div className="claim-customer-card">
								<div className="claim-customer-info">
									<div className="claim-avatar">
										{contract?.fullName
											?.charAt(0)
											?.toUpperCase() || "C"}
									</div>

									<div className="claim-customer-content">
										<span className="claim-label">
											{__t("uiText.text050")}</span>

										<h4>
											{displayValue(
												contract.fullName
											)}
										</h4>

										<div className="claim-customer-meta">
											<span>
												<i className="fas fa-phone" />
												{displayValue(
													contract.phone
												)}
											</span>

											<span>
												<i className="fas fa-map-marker-alt" />
												{displayValue(
													contract.address
												)}
											</span>

											<span>
												<i className="fas fa-user-tie" />
												{__t("uiText.text420")}{" "}
												{displayValue(
													contract.agentCode
												)}
											</span>
										</div>
									</div>
								</div>

								<div className="claim-buttons">
									{!view && (<button
										type="button"
										className="claim-btn claim-btn-primary"
										data-bs-toggle="modal"
										data-bs-target="#approvedPopupModal"
										onClick={() =>
											setRequest({
												file: null,
											})
										}
									>
										<i className="fas fa-check-circle" />
										{t("button.approveClame")}
									</button>)}

									<button
										type="button"
										className="claim-btn claim-btn-outline"
										disabled={
											downloadingType !== null
										}
										onClick={() =>
											downloadPDF(clame?.id, 1)
										}
									>
										<i
											className={
												downloadingType === 1
													? "fas fa-spinner fa-spin"
													: "fas fa-file-pdf"
											}
										/>

										{t(
											"button.clameDownloadPDF"
										)}
									</button>

									<button
										type="button"
										className="claim-btn claim-btn-outline"
										disabled={
											downloadingType !== null
										}
										onClick={() =>
											downloadPDF(clame?.id, 2)
										}
									>
										<i
											className={
												downloadingType === 2
													? "fas fa-spinner fa-spin"
													: "fas fa-file-contract"
											}
										/>

										{t("button.clameCovr")}
									</button>
								</div>
							</div>

							<div className="claim-summary-grid">
								<SummaryCard
									icon="fa-money-bill-wave"
									label={t("contract.moneyClame")}
									value={`${FormatCurrencys(
										clame?.claimAmount || 0
									)} ${t("currentcy.kip")}`}
									type="blue"
								/>

								<SummaryCard
									icon="fa-calendar-day"
									label={t(
										"contract.dateofAccident"
									)}
									value={
										clame?.deadDate
											? dateToString(
												clame.deadDate
											)
											: "-"
									}
									type="orange"
								/>

								<SummaryCard
									icon="fa-shield-alt"
									label={t("uiLabels.insurancePackage")}
									value={
										isLa()
											? displayValue(
												contract.optionNameLa
											)
											: displayValue(
												contract.optionNameEn
											)
									}
									type="green"
								/>

								<SummaryCard
									icon="fa-receipt"
									label={t("uiLabels.premium")}
									value={`${FormatCurrencys(
										contract.packagePrice || 0
									)} ${t("currentcy.kip")}`}
									type="purple"
								/>
							</div>

							<div className="row g-4">
								<div className="col-xl-8 col-lg-7">
									<div className="claim-card">
										<CardHeader
											icon="fa-clipboard-list"
											title={t(
												"contract.clameInfo"
											)}
											description={__t("uiText.text101")}
										/>

										<div className="claim-info-grid">
											<InfoItem
												icon="fa-car-crash"
												label={t(
													"contract.claimTypeVehicle"
												)}
												value={t(
													`causeList.${clame?.claimTypeId}`
												)}
											/>

											<InfoItem
												icon="fa-calendar-alt"
												label={t(
													"contract.dateofAccident"
												)}
												value={
													clame?.deadDate
														? dateToString(
															clame.deadDate
														)
														: "-"
												}
											/>

											<InfoItem
												icon="fa-money-check-alt"
												label={t(
													"contract.moneyClame"
												)}
												value={`${FormatCurrencys(
													clame?.claimAmount ||
													0
												)} ${t(
													"currentcy.kip"
												)}`}
											/>

											<InfoItem
												icon="fa-align-left"
												label={t(
													"contract.clameDescriptionVehicle"
												)}
												value={displayValue(
													clame?.description
												)}
												full
											/>
										</div>

										{clame?.documentPath && (
											<button
												type="button"
												className="claim-document"
												onClick={
													openClaimDocument
												}
											>
												<div className="claim-document-icon">
													<i className="fas fa-file-pdf" />
												</div>

												<div>
													<strong>
														{t(
															"contract.docClameVehicle"
														)}
													</strong>

													<span>
														{__t("uiText.text102")}</span>
												</div>

												<i className="fas fa-external-link-alt claim-document-open" />
											</button>
										)}
									</div>

									<div className="claim-card mt-4">
										<CardHeader
											icon="fa-images"
											title={t(
												"contract.documentImage"
											)}
											description={__t("uiText.text103")}
										/>

										{contract?.imagePath?.length >
											0 ? (
											<Gallery>
												<div className="claim-gallery">
													{contract.imagePath.map(
														(
															image,
															index
														) => {
															const imageUrl = `${process.env.REACT_APP_SERVER_URL}/view/display${image}`;

															return (
																<Item
																	key={
																		index
																	}
																	original={
																		imageUrl
																	}
																	thumbnail={
																		imageUrl
																	}
																	width={
																		1200
																	}
																	height={
																		900
																	}
																>
																	{({
																		ref,
																		open,
																	}) => (
																		<button
																			type="button"
																			ref={
																				ref
																			}
																			className="claim-gallery-item"
																			onClick={
																				open
																			}
																		>
																			<img
																				src={
																					imageUrl
																				}
																				alt={`Claim ${index +
																					1
																					}`}
																			/>

																			<div className="claim-gallery-overlay">
																				<i className="fas fa-search-plus" />
																				<span>
																					{__t("uiText.text104")}</span>
																			</div>
																		</button>
																	)}
																</Item>
															);
														}
													)}
												</div>
											</Gallery>
										) : (
											<div className="claim-no-image">
												<i className="far fa-images" />
												<span>
													{__t("uiText.text105")}</span>
											</div>
										)}
									</div>
								</div>

								<div className="col-xl-4 col-lg-5">
									<div className="claim-card claim-vehicle-card">
										<CardHeader
											icon="fa-car"
											title={t(
												"contract.carInfo"
											)}
											description={__t("uiText.text106")}
										/>

										<div className="vehicle-main">
											<div className="vehicle-icon">
												<i className="fas fa-car-side" />
											</div>

											<div>
												<span>{__t("uiText.text107")}</span>

												<strong>
													{isLa()
														? displayValue(
															contract.brandName
														)
														: displayValue(
															contract.brandNameEn ||
															contract.brandName
														)}
													{" - "}
													{displayValue(
														contract.vehicleModel
													)}
												</strong>
											</div>
										</div>

										<VehicleRow
											label={t(
												"contract.contractNumber"
											)}
											value={
												contract.contractNumber
											}
											highlight
										/>

										<VehicleRow
											label={t(
												"contract.vehiclePower"
											)}
											value={
												contract.vehiclePower
											}
										/>

										<VehicleRow
											label={t(
												"contract.engineNo"
											)}
											value={contract.engineNo}
										/>

										<VehicleRow
											label={t("uiLabels.chassisNumber")}
											value={
												contract.vehicleIdentificationNo
											}
										/>

										<VehicleRow
											label={t(
												"contract.licensePlate"
											)}
											value={
												contract.licensePlate
											}
											highlight
										/>

										<VehicleRow
											label={t(
												"contract.signDate"
											)}
											value={
												contract.signedDateCreate
													? dateToString(
														contract.signedDateCreate,
														"DD/MM/YYYY"
													)
													: "-"
											}
										/>

										<VehicleRow
											label={t(
												"contract.expiredDate"
											)}
											value={
												contract.expiredDate
											}
										/>

										{/* <VehicleRow
											label={t(
												"contract.gender.label"
											)}
											value={
												contract.gender !==
													null &&
													contract.gender !==
													undefined
													? t(
														`contract.gender.${contract.gender}`
													)
													: "-"
											}
										/> */}
									</div>
								</div>
							</div>
						</>
					)}
				</div>
			</section>

			<CopyrightFooter />

			<div
				className="modal fade"
				id="approvedPopupModal"
				tabIndex="-1"
			>
				<div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
					<div className="modal-content claim-modal">
						<div className="claim-modal-header">
							<div className="claim-modal-title">
								<div className="claim-modal-icon">
									<i className="fas fa-check-circle" />
								</div>

								<div>
									<h3>
										{t("contract.approvedForm")}
									</h3>

									<p>
										{__t("uiText.text108")}</p>
								</div>
							</div>

							<button
								type="button"
								className="claim-modal-close"
								data-bs-dismiss="modal"
							>
								<i className="fas fa-times" />
							</button>
						</div>

						<form onSubmit={handleSubmitApprove}>
							<div className="modal-body claim-modal-body">
								<label className="claim-upload-title">
									{t("contract.file")}
									<span className="text-danger">
										*
									</span>
								</label>

								<p className="claim-upload-description">
									{__t("uiText.text109")}</p>

								<div className="claim-upload-box">
									<FileUploadGrid
										multiple={false}
										folderName="clameVehicle"
										onChange={handleImageSelect}
										accept="image/*,application/pdf"
										required
									/>
								</div>

								<div className="claim-warning">
									<i className="fas fa-info-circle" />

									<span>
										{__t("uiText.text110")}</span>
								</div>
							</div>

							<div className="claim-modal-footer">
								<button
									type="button"
									className="claim-btn claim-btn-cancel"
									data-bs-dismiss="modal"
									disabled={submitting}
								>
									<i className="fas fa-times" />
									{__t("uiText.text067")}</button>

								<button
									type="submit"
									className="claim-btn claim-btn-primary"
									disabled={submitting}
								>
									<i
										className={
											submitting
												? "fas fa-spinner fa-spin"
												: "fas fa-check"
										}
									/>

									{submitting
										? __t("uiText.text111")
										: t("button.save")}
								</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
	);
};

const SummaryCard = ({
	icon,
	label,
	value,
	type,
}) => (
	<div className={`claim-summary-card claim-summary-${type}`}>
		<div className="claim-summary-icon">
			<i className={`fas ${icon}`} />
		</div>

		<div>
			<span>{label}</span>
			<strong>{value}</strong>
		</div>
	</div>
);

const CardHeader = ({
	icon,
	title,
	description,
}) => (
	<div className="claim-card-header">
		<div className="claim-card-header-icon">
			<i className={`fas ${icon}`} />
		</div>

		<div>
			<h4>{title}</h4>
			<p>{description}</p>
		</div>
	</div>
);

const InfoItem = ({
	icon,
	label,
	value,
	full = false,
}) => (
	<div
		className={`claim-info-item ${full ? "claim-info-full" : ""
			}`}
	>
		<div className="claim-info-icon">
			<i className={`fas ${icon}`} />
		</div>

		<div>
			<span>{label}</span>
			<strong>{value || "-"}</strong>
		</div>
	</div>
);

const VehicleRow = ({
	label,
	value,
	highlight = false,
}) => (
	<div className="vehicle-row">
		<span>{label}</span>

		<strong className={highlight ? "vehicle-highlight" : ""}>
			{value || "-"}
		</strong>
	</div>
);

export default Index;